import React from "react";
import { Menu, Dropdown, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { v4 } from "uuid";
import { slideAction, saveMirrorToCloudinary } from "../../../store/slideSlice";
import { useDispatch, useSelector } from "react-redux";
import shapeIcon from "../../../assets/shapes.svg";
import {
  SHAPE_CATALOG,
  SHAPE_GROUPS,
} from "../../Slide/SlideContents/shapes/geometry/presetRegistry";
import { PRESETS } from "../../Slide/SlideContents/shapes/geometry/presets";
import SubMenu from "antd/lib/menu/SubMenu";
import { emitElementAdd } from "../../../Socket/Socket";
import { slideAPI } from "../../../store/api";
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getSnapshot } from "../../../utils/utils";
import LayoutEnum from "../../../utils/layoutEnum";
import { getUpdatedSlides } from "../../../utils/helper";

export const ShapesDropdown = ({ currentSlideId, presentationId, onMenuOpenChange }) => {
  const {
    createNewElementInDatabase,
    saveMirrorInDatabase,
  } = slideAPI;

  const dispatch = useDispatch();
  const { id } = useParams();

  const isMasterSlide = useSelector((state) => state.slide.isMasterSlide);
  const masterSlideId = useSelector(state => state.slide.masterSlideId);
  const existingSlides = useSelector((state) => state.slide.slides);
  const mirrorSlides = useSelector((state) => state.slide.mirrorSlides);

  const addShape = (e, type, preset, presetAdj) => {
    if (!currentSlideId) {
      return;
    }
    let draw = false,
      tempBox,
      tempPath,
      slideContainer,
      slideContent,
      x1,
      y1,
      x2,
      y2;
    let lockScreen = document.createElement("div");
    lockScreen.setAttribute("style", "width:100%; height:100%; position: absolute; background: transparent; cursor: crosshair; z-index: 9999999999");
    // slideContainer = document.querySelector("#mainContainer");
    slideContent = document.getElementById("slide01");
    if (isMasterSlide) {
      slideContent = document.getElementById("master-slide");
    }
    slideContent.appendChild(lockScreen);
    const pageWidth = window.screen.width > 2200 ? 1800 : window.screen.width > 1540 ? 1200 : window.screen.width > 1200 ? 960 : window.screen.width > 992 ? 848 : window.screen.width > 768 ? 700 : window.screen.width > 490 ? 490 : 300;
    const pageHeight = window.screen.width > 2200 ? 1020 : window.screen.width > 1540 ? 700 : window.screen.width > 1200 ? 540 : window.screen.width > 992 ? 500 : window.screen.width > 768 ? 400 : window.screen.width > 490 ? 290 : 180;

    function mouseDown(e) {
      e.preventDefault();
      draw = true;
      x1 = e.offsetX;
      y1 = e.offsetY;
      // Draw the preview from the same preset geometry the shape will render
      // with, so what you drag out is what you get.
      const SVG_NS = "http://www.w3.org/2000/svg";
      tempBox = document.createElementNS(SVG_NS, "svg");
      tempBox.setAttribute("style", `width: ${0}px;height: ${0}px; position: absolute; left:${x1}px; top:${y1}px; overflow: visible;`);
      tempBox.setAttribute("id", "temp");
      tempPath = document.createElementNS(SVG_NS, "path");
      tempPath.setAttribute("fill", "none");
      tempPath.setAttribute("stroke", "#444");
      tempPath.setAttribute("stroke-width", "1");
      tempBox.appendChild(tempPath);
      lockScreen.appendChild(tempBox);
    }
    function mouseMove(e) {
      if (draw) {
        x2 = e.offsetX;
        y2 = e.offsetY;
        const w = x2 - x1;
        const h = y2 - y1;
        tempBox.setAttribute("style", `width: ${w}px;height: ${h}px; position: absolute; left:${x1}px; top:${y1}px; overflow: visible;`);
        if (w > 1 && h > 1) {
          tempBox.setAttribute("viewBox", `0 0 ${w} ${h}`);
          tempPath.setAttribute("d", preset.path({ x: 0.5, y: 0.5, width: w - 1, height: h - 1 }, presetAdj));
        }
      }
    }
    function mouseUp(e) {
      lockScreen.removeChild(tempBox);
      if (isMasterSlide && masterSlideId) {
        currentSlideId = masterSlideId;
      }
      // slideContainer.removeEventListener('mousemove', mouseMove);
      if (x2 === 0 || x2 === undefined) {
        x2 = x1 + 200;
      }
      if (y2 === 0 || y2 === undefined) {
        y2 = y1 + 200;
      }
      const shapeId = type + 'shape' + v4();
      let elementData = {
        shapeId,
        currentSlideId,
        style: { width: (x2 - x1) / pageWidth * 100 + '%', height: (y2 - y1) / pageHeight * 100 + '%', position: 'absolute', left: (x1) / pageWidth * 100 + '%', top: (y1) / pageHeight * 100 + '%' }
      }
      if (!isMasterSlide) {
        dispatch(slideAction.addShape(elementData));
        const updatedSlides = getUpdatedSlides(elementData,'shape',existingSlides);
        let data = {
          slides: updatedSlides,
          mirrorSlides: mirrorSlides
        }
        createNewElementInDatabase(presentationId, currentSlideId, shapeId, {
          delta: {
            ops: [{ insert: "" }]
          }, styles: elementData.style
        }, 'shape', dispatch, data);
      }
      else if (isMasterSlide) {
        const isMainMasterSlide = !Object.values(LayoutEnum).some(layout => currentSlideId.toLowerCase().includes(layout.toLowerCase()));
        if (isMainMasterSlide) {
          dispatch(slideAction.addShape(elementData));
          Object.keys(existingSlides).forEach((slideId) => {
            const isMasterLayout = Object.values(LayoutEnum).some((enumValue) =>
              slideId.includes(enumValue)
            );
            if (isMasterLayout) {
              let payload = {
                ...elementData,
                style: { ...elementData.style, pointerEvents: 'none' },
                currentSlideId: slideId
              }
              dispatch(slideAction.addShape(payload));
            }
          });
          slideAPI.createMultipleNewElementInDatabase(presentationId, shapeId, {
            delta: {
              ops: [{ insert: "" }]
            }, styles: elementData.style
          }, 'shape');
        }
        else {
          const elementId = `${currentSlideId.split('-')[2]}-${elementData.shapeId}`;
          dispatch(slideAction.addShape({ ...elementData, shapeId: elementId }));
          slideAPI.createMultipleNewElementInDatabase(presentationId, elementId, {
            delta: {
              ops: [{ insert: "" }]
            }, styles: elementData.style
          }, 'shape',existingSlides[currentSlideId].layoutType);
        }
        // handleMasterSlideUpdate(elementData);
      }
      emitElementAdd({ roomId: presentationId, elementType: "shape", elementData: elementData });
      // dispatch(slideAction.addCircle({circleId: circleId , style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', borderRadius: "50", position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
      slideContent.style.cursor = 'default';
      draw = false;
      x2 = 0;
      y2 = 0;
      slideContent.removeChild(lockScreen);
    }

    lockScreen.addEventListener('mousedown', mouseDown, { once: true });
    lockScreen.addEventListener('mousemove', mouseMove, false);
    lockScreen.addEventListener('mouseup', mouseUp, { once: true });

  }
  function delay(t) {
    return new Promise(resolve => setTimeout(resolve, t));
  }

  async function handleMasterSlideUpdate(elementData) {
    let mirrorDataArray = [];
    const slideKeys = Object.keys(existingSlides).filter(slideId => !slideId.includes('master'));
    for (let slideId of slideKeys) {
      try {
        dispatch(slideAction.addShape({
          ...elementData,
          style: {
            ...elementData.style,
            pointerEvents: 'none'
          },
          currentSlideId: slideId
        }));
        dispatch(slideAction.setCurrentSlide(slideId));
        await delay(500);
        const dataUrl = await getSnapshot();
        dispatch(
          saveMirrorToCloudinary({
            dataId: slideId,
            mirrorSlideDataUrl: dataUrl,
            presentationId: id,
          })
        );
        mirrorDataArray.push({
          imageId: slideId,
          b64Data: dataUrl,
        })
      }
      catch (err) {
        console.error('Crash....', err);
      }
    }
    slideAPI.createMultipleNewElementInDatabase(id, elementData.shapeId, {
      delta: {
        ops: [{ insert: "" }]
      }, styles: {
        ...elementData.style,
        pointerEvents: 'none'
      },
    }, 'shape');
    slideAPI.saveMultipleMirrorInDatabase(id, mirrorDataArray);
    dispatch(slideAction.setCurrentSlide(masterSlideId));
  }
  // const addRectangle = () =>{
  //     slideContainer = document.querySelector("#mainContainer");
  //     slideContent = document.getElementById("slide01");
  //     slideContent.style.cursor = 'crosshair';

  //     function rectangleMouseDown(e){
  //       e.preventDefault();
  //       draw = true;
  //       x1= e.offsetX;
  //       y1= e.offsetY;
  //        tempBox = document.createElement("img");
  //        tempBox.setAttribute("style",`width: ${0}px;height: ${0}px; position: absolute; left:${x1}px; top:${y1}px;`);
  //        tempBox.setAttribute("src",basicRectangle)
  //        tempBox.setAttribute("id","temp");
  //       //  tempBox.classList.add("border");
  //        slideContent.appendChild(tempBox);
  //      }
  //      function rectangleMouseMove(e){
  //        // setCordinate((prev) => {})
  //        if(draw){
  //         x2 = e.offsetX;
  //         y2 = e.offsetY;
  //        tempBox.setAttribute("style",`width: ${x2-x1}px;height: ${y2-y1}px; position: absolute; left:${x1}px; top:${y1}px;`);
  //          // console.log(cordX, cordY);
  //        }
  //      }
  //      function rectangleMouseUp(e){
  //       slideContent.removeChild(tempBox);
  //       slideContainer.removeEventListener('mousemove', rectangleMouseMove);
  //       const shapeId = 'rectangle' + v4();
  //       dispatch(slideAction.addShape({shapeId, style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       // dispatch(slideAction.addCircle({circleId: circleId , style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', borderRadius: "50", position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       slideContent.style.cursor = 'default';
  //        draw = false;
  //        x2 = 0;
  //        y2 = 0;
  //      }

  //      slideContainer.addEventListener('mousedown', rectangleMouseDown, {once: true});
  //      slideContainer.addEventListener('mousemove', rectangleMouseMove, false);
  //      slideContainer.addEventListener('mouseup', rectangleMouseUp, {once: true});

  // }

  // const addCircle = () =>{
  //     slideContainer = document.querySelector("#mainContainer");
  //     slideContent = document.getElementById("slide01");
  //     slideContent.style.cursor = 'crosshair';

  //     function circleMouseDown(e){
  //       e.preventDefault();
  //       draw = true;
  //        tempBox = document.createElement("div");
  //        tempBox.setAttribute("id","temp");
  //       //  tempBox.classList.add("border");
  //        slideContent.appendChild(tempBox);
  //        x1= e.offsetX;
  //        y1= e.offsetY;
  //      }
  //      function circleMouseMove(e){
  //        // setCordinate((prev) => {})
  //        if(draw){
  //         x2 = e.offsetX;
  //         y2 = e.offsetY;
  //        tempBox.setAttribute("style",`width: ${x2-x1}px;height: ${y2-y1}px; position: absolute; left:${x1}px; top:${y1}px; border-radius: 50%; border: 2px solid #000;`);
  //          // console.log(cordX, cordY);
  //        }
  //      }
  //      function circleMouseUp(e){
  //       slideContent.removeChild(tempBox);
  //       slideContainer.removeEventListener('mousemove', circleMouseMove);
  //       const shapeId = 'circle' + v4();
  //       dispatch(slideAction.addShape({shapeId, style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       // dispatch(slideAction.addCircle({circleId: circleId , style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', borderRadius: "50", position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       slideContent.style.cursor = 'default';
  //        draw = false;
  //        x2 = 0;
  //        y2 = 0;
  //      }

  //      slideContainer.addEventListener('mousedown', circleMouseDown, {once: true});
  //      slideContainer.addEventListener('mousemove', circleMouseMove, false);
  //      slideContainer.addEventListener('mouseup', circleMouseUp, {once: true});

  //   }

  // const addTriangle = () =>{
  //     slideContainer = document.querySelector("#mainContainer");
  //     slideContent = document.getElementById("slide01");
  //     slideContent.style.cursor = 'crosshair';

  //     function triangleMouseDown(e){
  //       e.preventDefault();
  //       draw = true;
  //       x1= e.offsetX;
  //       y1= e.offsetY;
  //        tempBox = document.createElement("img");
  //        tempBox.setAttribute("style",`width: 0px; height: 0px; position: absolute; left:${x1}px; top:${y1}px;`);
  //        tempBox.setAttribute('src',basicTriangle);
  //        tempBox.setAttribute("id","temp");
  //       //  tempBox.classList.add("border");
  //        slideContent.appendChild(tempBox);
  //      }
  //      function triangleMouseMove(e){
  //        // setCordinate((prev) => {})
  //        if(draw){
  //         x2 = e.offsetX;
  //         y2 = e.offsetY;
  //        tempBox.setAttribute("style",`width: ${x2-x1}px;height: ${y2-y1}px; position: absolute; left:${x1}px; top:${y1}px;`);
  //          // console.log(cordX, cordY);
  //        }
  //      }
  //      function triangleMouseUp(e){
  //       slideContent.removeChild(tempBox);
  //       slideContainer.removeEventListener('mousemove', triangleMouseMove);
  //       const shapeId = 'triangle' + v4();
  //       dispatch(slideAction.addShape({shapeId, style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       // dispatch(slideAction.addCircle({circleId: circleId , style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', borderRadius: "50", position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       slideContent.style.cursor = 'default';
  //        draw = false;
  //        x2 = 0;
  //        y2 = 0;
  //      }

  //      slideContainer.addEventListener('mousedown', triangleMouseDown, {once: true});
  //      slideContainer.addEventListener('mousemove', triangleMouseMove, false);
  //      slideContainer.addEventListener('mouseup', triangleMouseUp, {once: true});

  // }
  // const addCalloutRect = () =>{
  //     slideContainer = document.querySelector("#mainContainer");
  //     slideContent = document.getElementById("slide01");
  //     slideContent.style.cursor = 'crosshair';

  //     function calloutRectMouseDown(e){
  //       e.preventDefault();
  //       draw = true;
  //        tempBox = document.createElement("img");
  //        tempBox.setAttribute("style",`width: 0px;height: 0px; position: absolute; left:${x1}px; top:${y1}px;`);
  //        tempBox.setAttribute('src',calloutRect);
  //        tempBox.setAttribute("id","temp");
  //       //  tempBox.classList.add("border");
  //        slideContent.appendChild(tempBox);
  //        x1= e.offsetX;
  //        y1= e.offsetY;
  //      }
  //      function calloutRectMouseMove(e){
  //        // setCordinate((prev) => {})
  //        if(draw){
  //         x2 = e.offsetX;
  //         y2 = e.offsetY;
  //        tempBox.setAttribute("style",`width: ${x2-x1}px;height: ${y2-y1}px; position: absolute; left:${x1}px; top:${y1}px;`);
  //          // console.log(cordX, cordY);
  //        }
  //      }
  //      function calloutRectMouseUp(e){
  //       slideContent.removeChild(tempBox);
  //       slideContainer.removeEventListener('mousemove', calloutRectMouseMove);
  //       const shapeId = 'callout' + v4();
  //       dispatch(slideAction.addShape({shapeId, style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       // dispatch(slideAction.addCircle({circleId: circleId , style:{ width: (x2-x1)/960 * 100 +'%', height: (y2-y1)/540 * 100 + '%', borderRadius: "50", position: 'absolute', left: (x1)/960 * 100 +'%', top: (y1)/540 * 100 +'%'}}))
  //       slideContent.style.cursor = 'default';
  //        draw = false;
  //        x2 = 0;
  //        y2 = 0;
  //      }

  //      slideContainer.addEventListener('mousedown', calloutRectMouseDown, {once: true});
  //      slideContainer.addEventListener('mousemove', calloutRectMouseMove, false);
  //      slideContainer.addEventListener('mouseup', calloutRectMouseUp, {once: true});

  // }

  const menu = (
    <Menu key={"abc"}>
      {/* <SubMenu key={"xyz"} title="Shapes" id='shapes-menu'> */}
      <Menu.Item key="0" className="shape-menu-item" style={{ width: 'auto', margin: '0px' }} id='shapes-menu'>
        <div className="shape-picker">
          {SHAPE_GROUPS.map((group) => (
            <div key={group} className="shape-group">
              <div className="shape-group-label">{group}</div>
              <div className="shape-grid">
                {SHAPE_CATALOG.filter((entry) => entry.group === group).map(
                  ({ token, presetName, label }) => {
                    const preset = PRESETS[presetName];
                    const adj = preset.adjustments.reduce(
                      (a, s) => ({ ...a, [s.name]: s.default }),
                      {}
                    );
                    return (
                      <div
                        key={token}
                        className="shape-item"
                        title={label}
                        onClick={(e) => addShape(e, token, preset, adj)}
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" aria-label={label}>
                          <path
                            d={preset.path({ x: 1.5, y: 1.5, width: 17, height: 17 }, adj)}
                            fill="none"
                            stroke="#444"
                            strokeWidth="1"
                          />
                        </svg>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          ))}
        </div>
      </Menu.Item>
      {/* </SubMenu> */}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      onVisibleChange={onMenuOpenChange}
      disabled={currentSlideId ? false : true}
    >
      <span
        style={{ color: 'inherit' }}
        onClick={(e) => e.preventDefault()}
      >
        <CategoryOutlinedIcon
          fontSize="medium"
          style={{ width: "25px", height: "22px", verticalAlign: "top" }}
          alt={"toolbar-icon"}
        />
      </span>
    </Dropdown>
  );
};
